// type
import { NavItemType } from 'types/menu';
import { AppstoreAddOutlined, CreditCardOutlined, FileOutlined, FileTextOutlined, ProjectOutlined, TableOutlined } from '@ant-design/icons';
import { ModernIconPay } from 'utils/icons';
import { TemplateIcon } from 'utils/TaskManagementIcon/taskmanagemeneticon';

const ppf: NavItemType = {
  id: 'group-ppf',
  title: 'PPF',
  icon: AppstoreAddOutlined,
  type: 'group',
  children: [
    {
      id: 'PPF-Company-Profile',
      title: 'Company Profile',
      subtitle: 'Manage Company Profile',
      type: 'item',
      url: '/apps/ppf/companyprofile',
      icon: ProjectOutlined,
      featureID: 11
    },
    {
      id: 'Contractor Managements',
      title: 'Contractors',
      subtitle: 'Contractor Managements',
      type: 'item',
      url: '/contractors',
      icon: ProjectOutlined,
      featureID: 13
    },
    {
      id: 'New Contractor',
      title: 'New Contractor',
      subtitle: 'New Contractor',
      type: 'item',
      breadcrumbs: false,
      visible: false,
      url: '/contractors/new',
      icon: ProjectOutlined,
      featureID: 13
    },
    {
      id: 'edit Contractor',
      title: 'Edit Contractor',
      subtitle: 'Update contractor details, contact information, and company settings.',
      type: 'item',
      breadcrumbs: true,
      visible: false,
      url: '/contractors/edit/:contractorID',
      icon: ProjectOutlined,
      featureID: 13
    },

    {
      id: 'View Contractor',
      title: 'View Contractor',
      subtitle: 'View Contractor',
      type: 'item',
      breadcrumbs: true,
      visible: false,
      url: '/contractors/view/:contractorID',
      icon: ProjectOutlined,
      featureID: 13
    },
    {
      id: 'PPF Projects',
      title: 'Projects',
      subtitle: 'Manage Projects',
      type: 'item',
      url: '/apps/ppf/projects',
      icon: ProjectOutlined,
      featureID: 11,
    },

    /// Task board
    {
      id: 'task-board',
      title: 'Task Board',
      subtitle: 'View and manage Tasks',
      type: 'item',
      url: '/ppf/taskboard',
      icon: TableOutlined,
      featureID: 49,
      breadcrumbs: false,
      visible: true
    },
    {
      id: 'task-list',
      title: 'Task List',
      subtitle: 'View and manage Tasks',
      type: 'item',
      url: '/ppf/taskList',
      icon: TemplateIcon,
      featureID: 47,
      breadcrumbs: false,
      visible: true
    },
    {
      id: 'inspections',
      title: 'Inspections',
      subtitle: 'Review and manage remote inspections across your projects.',
      type: 'item',
      url: '/ppf/inspections',
      icon: TemplateIcon,
      featureID: 37,
      breadcrumbs: true,
      visible: true
    },
    // End Task Board


    {
      id: 'Plan Reviews',
      title: 'Plan Reviews',
      subtitle: 'Manage your plan review work queue',
      type: 'item',
      url: '/ppf/planReviews',
      icon: ProjectOutlined,
      featureID: 44,
    },
    {
      id: 'Plan Reviews',
      title: 'Plan Reviews',
      subtitle: 'Manage your plan review work queue',
      type: 'item',
      url: '/ppf/planReviews/:projectID',
      icon: ProjectOutlined,
      featureID: 44,
      breadcrumbs: false,
      visible: false
    },
    {
      id: 'PPF Invoices',
      title: 'Invoices',
      subtitle: 'View and manage invoices',
      type: 'item',
      url: '/ppf/invoices',
      icon: FileTextOutlined,
      featureID: 26,
    },
    {
      id: 'PPF Invoices',
      title: 'Invoices',
      subtitle: 'View and manage invoices',
      type: 'item',
      url: '/ppf/invoices/new',
      icon: FileTextOutlined,
      featureID: 26,
      visible: false,
      breadcrumbs: false,
    },

    {
      id: 'PPF Invoices',
      title: 'Invoices',
      subtitle: 'View and manage invoices',
      type: 'item',
      url: '/ppf/invoices/edit/:invoiceID',
      icon: FileTextOutlined,
      featureID: 26,
      visible: false,
      breadcrumbs: false,
    },

    {
      id: 'PPF Invoices',
      title: 'Invoices',
      subtitle: 'View and manage invoices',
      type: 'item',
      url: '/ppf/invoices/view/:invoiceID',
      icon: FileTextOutlined,
      featureID: 26,
      visible: false,
      breadcrumbs: false,
    },

    {
      id: 'PPF Projects Workspace',
      title: 'Projects',
      subtitle: 'Manage Projects',
      type: 'item',
      url: '/apps/ppf/projects/workspace/:projectID',
      icon: ProjectOutlined,
      featureID: 11,
      breadcrumbs: false,
      visible: false
    },
    {
      id: 'Proposal',
      title: 'Proposal',
      subtitle: 'Manage proposal details and cost estimates',
      type: 'item',
      url: '/apps/ppf/project/proposal/:proposalID',
      icon: ProjectOutlined,
      featureID: 19,
      breadcrumbs: false,
      visible: false
    },
    {
      id: 'PPF Payments',
      title: 'Payments',
      subtitle: 'View and manage payments',
      type: 'item',
      url: '/ppf/payments',
      icon: ModernIconPay,
      featureID: 27,
    },
    {
      id: 'New Payment',
      title: 'New Payment',
      subtitle: 'manage payments',
      type: 'item',
      url: '/ppf/payments/new',
      icon: ModernIconPay,
      featureID: 27,
      breadcrumbs: false,
      visible: false
    },
    {
      id: 'View Payment',
      title: 'View Payment',
      subtitle: 'manage payments',
      type: 'item',
      url: '/ppf/payments/view/:paymentID',
      icon: ModernIconPay,
      featureID: 27,
      breadcrumbs: false,
      visible: false
    },
    {
      id: 'Edit Payment',
      title: 'Edit Payment',
      subtitle: 'manage payments',
      type: 'item',
      url: '/ppf/payments/edit/:paymentID',
      icon: ModernIconPay,
      featureID: 27,
      breadcrumbs: false,
      visible: false
    },

    {
      id: 'Credits',
      title: 'Credits',
      subtitle: 'View and manage credits',
      type: 'item',
      url: '/apps/ppf/transactions/credits',
      icon: ProjectOutlined,
      featureID: 28,
    },
    {
      id: 'newCredit',
      title: 'New Credit',
      type: 'item',
      url: '/apps/ppf/transactions/credits/new',
      icon: ProjectOutlined,
      featureID: 28,
      visible: false
    },
    {
      id: 'Credits',
      title: 'Edit Credit',
      subtitle: 'View and manage credit',
      type: 'item',
      url: '/apps/ppf/transactions/credits/edit/:id',
      icon: ProjectOutlined,
      featureID: 28,
      visible: false,
      breadcrumbs: false
    },
    {
      id: 'Credits',
      title: 'View Credits',
      subtitle: 'View and manage credit',
      type: 'item',
      url: '/apps/ppf/transactions/credits/view/:id',
      icon: ProjectOutlined,
      featureID: 28,
      visible: false,
      breadcrumbs: false
    },
    {
      id: 'contractorsubscription',
      title: 'Contractor Subscription',
      subtitle: 'View and manage contractor subscription',
      type: 'item',
      url: '/apps/ppf/transactions/contractorsubscriptions',
      icon: ProjectOutlined,
      featureID: 30,
    },
    {
      id: 'newContractorSubscription',
      title: 'New Contractor Subscription',
      type: 'item',
      url: '/apps/ppf/transactions/contractorsubscriptions/new',
      icon: ProjectOutlined,
      featureID: 30,
      visible: false
    },
    {
      id: 'contractorsubscription',
      title: 'Edit Contractor Subscription',
      type: 'item',
      url: '/apps/ppf/transactions/contractorsubscriptions/edit/:id',
      icon: ProjectOutlined,
      featureID: 30,
      visible: false,
    },
    {
      id: 'contractorsubscription',
      title: 'View Contractor Subscription',
      type: 'item',
      url: '/apps/ppf/transactions/contractorsubscriptions/view/:id',
      icon: ProjectOutlined,
      featureID: 30,
      visible: false,
    },

    {
      id: 'masteragreement',
      title: 'Master Agreement',
      subtitle: 'Manage master agreement',
      type: 'item',
      url: '/contractors/masteragreement/:masterAgreementID',
      icon: CreditCardOutlined,
      featureID: 23,
      visible: false,
      breadcrumbs: false,
    },
    {
      id: 'masteragreement-view',
      title: 'Master Agreement',
      subtitle: 'Manage master agreement',
      type: 'item',
      url: '/contractors/masteragreement/view/:masterAgreementID',
      icon: CreditCardOutlined,
      featureID: 23,
      visible: false,
      breadcrumbs: false,
    },
    {
      id: 'parentcompany',
      title: 'Parent Companies',
      subtitle: 'Manage Contractor Parent Companies',
      type: 'item',
      url: '/apps/ppf/parentCompanies',
      icon: CreditCardOutlined,
      featureID: 34,
    },
  ],
};

export default ppf;
